 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLFM01 from '@/components/xhtml/fm01'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLGROVEATLANTICLITHUB from '@/components/xhtml/groveatlanticlithub'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLACKNOWLEDGMENT from '@/components/xhtml/acknowledgment'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLFOREWORD from '@/components/xhtml/foreword'
 import XHTMLPART01 from '@/components/xhtml/part01'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLPART02 from '@/components/xhtml/part02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLPART03 from '@/components/xhtml/part03'
 import XHTMLPARTTOC from '@/components/xhtml/parttoc'
 import XHTMLPARTINTRO from '@/components/xhtml/partintro'
 import XHTMLPARTPART1 from '@/components/xhtml/partpart1'
 import XHTMLPARTCH01 from '@/components/xhtml/partch01'
 import XHTMLPARTCH02 from '@/components/xhtml/partch02'
 import XHTMLPARTCH03 from '@/components/xhtml/partch03'
 import XHTMLPARTCH04 from '@/components/xhtml/partch04'
 import XHTMLPARTCH05 from '@/components/xhtml/partch05'
 import XHTMLPARTCH06 from '@/components/xhtml/partch06'
 import XHTMLPARTCH07 from '@/components/xhtml/partch07'
 import XHTMLPARTCH08 from '@/components/xhtml/partch08'
 import XHTMLPARTCH09 from '@/components/xhtml/partch09'
 import XHTMLPARTCH10 from '@/components/xhtml/partch10'
 import XHTMLPARTCH11 from '@/components/xhtml/partch11'
 import XHTMLPARTCH12 from '@/components/xhtml/partch12'
 import XHTMLPARTCH13 from '@/components/xhtml/partch13'
 import XHTMLPARTCH14 from '@/components/xhtml/partch14'
 import XHTMLPARTCH15 from '@/components/xhtml/partch15'
 import XHTMLPARTCH16 from '@/components/xhtml/partch16'
 import XHTMLPARTCH17 from '@/components/xhtml/partch17'
 import XHTMLPARTCH18 from '@/components/xhtml/partch18'
 import XHTMLPARTCH19 from '@/components/xhtml/partch19'
 import XHTMLPARTCH20 from '@/components/xhtml/partch20'
 import XHTMLPARTCH21 from '@/components/xhtml/partch21'
 import XHTMLPARTCH22 from '@/components/xhtml/partch22'
 import XHTMLPARTCH23 from '@/components/xhtml/partch23'
 import XHTMLPARTCH24 from '@/components/xhtml/partch24'
 import XHTMLPARTCH25 from '@/components/xhtml/partch25'
 import XHTMLPARTCH26 from '@/components/xhtml/partch26'
 import XHTMLPARTCH27 from '@/components/xhtml/partch27'
 import XHTMLPARTCH28 from '@/components/xhtml/partch28'
 import XHTMLPARTCH29 from '@/components/xhtml/partch29'
 import XHTMLPARTCH30 from '@/components/xhtml/partch30'
 import XHTMLPARTCH31 from '@/components/xhtml/partch31'
 import XHTMLPARTCH32 from '@/components/xhtml/partch32'
 import XHTMLPARTPART2 from '@/components/xhtml/partpart2'
 import XHTMLPARTPART3 from '@/components/xhtml/partpart3'
 import XHTMLPARTPART4 from '@/components/xhtml/partpart4'
 import XHTMLPARTNOTES from '@/components/xhtml/partnotes'
 import XHTMLPARTADDENDA from '@/components/xhtml/partaddenda'
 import XHTMLPART04 from '@/components/xhtml/part04'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/bibliography'
 import XHTMLFN1FORE from '@/components/xhtml/fn1fore'
 import XHTMLCH01FN1 from '@/components/xhtml/ch01fn1'
 import XHTMLCH01FN10 from '@/components/xhtml/ch01fn10'
 import XHTMLCH01FN11 from '@/components/xhtml/ch01fn11'
 import XHTMLCH01FN12 from '@/components/xhtml/ch01fn12'
 import XHTMLCH01FN13 from '@/components/xhtml/ch01fn13'
 import XHTMLCH01FN14 from '@/components/xhtml/ch01fn14'
 import XHTMLCH01FN15 from '@/components/xhtml/ch01fn15'
 import XHTMLCH01FN16 from '@/components/xhtml/ch01fn16'
 import XHTMLCH01FN17 from '@/components/xhtml/ch01fn17'
 import XHTMLCH01FN18 from '@/components/xhtml/ch01fn18'
 import XHTMLCH01FN2 from '@/components/xhtml/ch01fn2'
 import XHTMLCH01FN3 from '@/components/xhtml/ch01fn3'
 import XHTMLCH01FN4 from '@/components/xhtml/ch01fn4'
 import XHTMLCH01FN5 from '@/components/xhtml/ch01fn5'
 import XHTMLCH01FN6 from '@/components/xhtml/ch01fn6'
 import XHTMLCH01FN7 from '@/components/xhtml/ch01fn7'
 import XHTMLCH01FN8 from '@/components/xhtml/ch01fn8'
 import XHTMLCH01FN9 from '@/components/xhtml/ch01fn9'
 import XHTMLPART03FN1 from '@/components/xhtml/part03fn1'
 import XHTMLPART03FN2 from '@/components/xhtml/part03fn2'
 import XHTMLPART03FN3 from '@/components/xhtml/part03fn3'
 import XHTMLPART03FN4 from '@/components/xhtml/part03fn4'
 import XHTMLPART03FN5 from '@/components/xhtml/part03fn5'
 import XHTMLPART03FN6 from '@/components/xhtml/part03fn6'
 import XHTMLCH03FN1 from '@/components/xhtml/ch03fn1'
 import XHTMLCH03FN2 from '@/components/xhtml/ch03fn2'
 import XHTMLCH03FN3 from '@/components/xhtml/ch03fn3'
 import XHTMLCH03FN4 from '@/components/xhtml/ch03fn4'
 import XHTMLCH03FN5 from '@/components/xhtml/ch03fn5'
 import XHTMLCH03FN6 from '@/components/xhtml/ch03fn6'
 import XHTMLCH03FN7 from '@/components/xhtml/ch03fn7'
 import XHTMLCH03FN8 from '@/components/xhtml/ch03fn8'
 import XHTMLCH03FN9 from '@/components/xhtml/ch03fn9'
 import XHTMLCH03FNA1 from '@/components/xhtml/ch03fna1'
 import XHTMLCH03FNA2 from '@/components/xhtml/ch03fna2'
 import XHTMLCH03FNA3 from '@/components/xhtml/ch03fna3'
 import XHTMLCH03FNA4 from '@/components/xhtml/ch03fna4'
 import XHTMLCH03FNA5 from '@/components/xhtml/ch03fna5'
 import XHTMLCH03FNA6 from '@/components/xhtml/ch03fna6'
 import XHTMLCH03FNA7 from '@/components/xhtml/ch03fna7'
 import XHTMLCH03FNA8 from '@/components/xhtml/ch03fna8'
 import XHTMLCH03FNA9 from '@/components/xhtml/ch03fna9'
 import XHTMLCH04FN1 from '@/components/xhtml/ch04fn1'
 import XHTMLCH05FN1 from '@/components/xhtml/ch05fn1'
 import XHTMLCH05FN2 from '@/components/xhtml/ch05fn2'
 import XHTMLCH05FN3 from '@/components/xhtml/ch05fn3'
 import XHTMLCH05FN4 from '@/components/xhtml/ch05fn4'
 import XHTMLCH06FN1 from '@/components/xhtml/ch06fn1'
 import XHTMLCH06FN2 from '@/components/xhtml/ch06fn2'
 import XHTMLPARTINTROFN1 from '@/components/xhtml/partintrofn1'
 import XHTMLPARTINTROFN2 from '@/components/xhtml/partintrofn2'
 import XHTMLPARTCH32FN3 from '@/components/xhtml/partch32fn3'
 import XHTMLPARTPART2FN4 from '@/components/xhtml/partpart2fn4'
 import XHTMLCH07FN1 from '@/components/xhtml/ch07fn1'
 import XHTMLCH07FN2 from '@/components/xhtml/ch07fn2'
 import XHTMLCH07FN3 from '@/components/xhtml/ch07fn3'
 import XHTMLCH07FN4 from '@/components/xhtml/ch07fn4'
 import XHTMLCH07FN5 from '@/components/xhtml/ch07fn5'
 import XHTMLCH07FN6 from '@/components/xhtml/ch07fn6'
 import XHTMLCH07FN7 from '@/components/xhtml/ch07fn7'
 import XHTMLCH07FN8 from '@/components/xhtml/ch07fn8'
 import XHTMLCH08FN1 from '@/components/xhtml/ch08fn1'
 import XHTMLCH08FN2 from '@/components/xhtml/ch08fn2'
 import XHTMLCH08FN3 from '@/components/xhtml/ch08fn3'
 import XHTMLCH08FN4 from '@/components/xhtml/ch08fn4'
 import XHTMLBIBLIOFN1 from '@/components/xhtml/bibliofn1'
 import XHTMLBIBLIOFN2 from '@/components/xhtml/bibliofn2'
 import XHTMLBIBLIOFN3 from '@/components/xhtml/bibliofn3'
 import XHTMLBIBLIOFN4 from '@/components/xhtml/bibliofn4'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/halftitle",
 			"name" : "xhtml/halftitle",
 			"component" : XHTMLHALFTITLE
 		},
 		{
 			"path" : "/xhtml/fm01",
 			"name" : "xhtml/fm01",
 			"component" : XHTMLFM01
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/groveatlanticlithub",
 			"name" : "xhtml/groveatlanticlithub",
 			"component" : XHTMLGROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/copyright",
 			"name" : "xhtml/copyright",
 			"component" : XHTMLCOPYRIGHT
 		},
 		{
 			"path" : "/xhtml/acknowledgment",
 			"name" : "xhtml/acknowledgment",
 			"component" : XHTMLACKNOWLEDGMENT
 		},
 		{
 			"path" : "/xhtml/dedication",
 			"name" : "xhtml/dedication",
 			"component" : XHTMLDEDICATION
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/foreword",
 			"name" : "xhtml/foreword",
 			"component" : XHTMLFOREWORD
 		},
 		{
 			"path" : "/xhtml/part01",
 			"name" : "xhtml/part01",
 			"component" : XHTMLPART01
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js